import { HttpClient } from '@angular/common/http';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  constructor(private http: HttpClient) {}


  public checkUserRoles(roles: string[]): boolean {
    return true;
    /*
    const listRoles = this.getGroupsFromToken();
    if (roles === null || roles.length === 0) {
      return true;
    }

    return roles.some((role) => {
      if (!listRoles.includes(role)) {
        return false;
      }
      console.log ('dejamos pasar porque el usuario tiene el role: ' + role);
      return true;
    });
    */
  }


  /*
  parseGroups(groups: any): string[] {
    const parsedGroups: string[] = [];
    groups.value.forEach((groupInfo) => {
      parsedGroups.push(groupInfo.displayName);
    });
    return parsedGroups;
  }
  */
}
